import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const factoryItemList = this.props.factoryItemList;
    return (
      <div>
        <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
          <style>
            {`
                      @page {
                          size: A4 portrait;
                          margin-top: 0.75in;
                          margin-bottom: 0.75in;
                          margin-right: 0.5in;
                          margin-left: 0.5in;
                      }
                  `}
          </style>
          <h3><u><center>Factory Item Details Report - KTF</center></u></h3>
          <br />
          <div className="row pl-2 pb-4 pt-4">
            <center>
              <div className="col" style={{ fontSize: '12px' }}><left><b>Group: </b> {searchData.groupName} </left></div>
              <div className="col" style={{ fontSize: '12px' }}><left><b>Factory : </b> {searchData.factoryName}</left></div>
              <div className="col" style={{ fontSize: '12px' }}><left><b>Route : </b> {searchData.routeName === undefined ? "All route" : searchData.routeName}</left></div>
              <div className="col" style={{ fontSize: '12px' }}><left><b>Item Category : </b> {searchData.itemCategoryName === undefined ? "All Item Categories" : searchData.itemCategoryName}</left></div>
              <div className="col" style={{ fontSize: '12px' }}><left><b>Factory Item : </b> {searchData.factoryItemName === undefined ? "All Factory Items" : searchData.factoryItemName}</left></div>
              <div className="col" style={{ fontSize: '12px' }}><left><b>From date : </b> {searchData.startDate} - <b>To date : </b> {searchData.endDate}</left></div>
            </center>
          </div>
          <br />
          <TableContainer component={Paper}>
            <Table aria-label="simple table" size='small'>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Route Name</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Date</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Reg No</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Supplier Name</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Category</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Item</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Quantity</TableCell>
                  <TableCell align="center" style={{ fontSize: '10px', fontWeight: 'bold', border: '1px solid #ccc', padding: '3px' }}>Total Price (Rs)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>                {factoryItemList.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.routeName}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.date.split('T')[0]}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.registrationNumber}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.name}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.categoryName}</TableCell>
                    <TableCell component="th" scope="row" align="left" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.itemName}</TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.approvedQuantity}</TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ fontSize: '10px', border: "1px solid #ccc", padding: '4px' }}> {data.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    );
  }
}

